import { type fabric } from 'fabric';
import type Canvas from '../objects/Canvas';
import type Stylus from './Stylus';
import { type MouseEventData } from '../external-types';
import { type IPoint } from 'fabric/fabric-impl';
import { componentBuilder } from '../utils/componentBuilder';
import { type ComponentNames } from '../objects/components';
import DraggableBrush from './DraggableBrush';

export interface WhiteboardObject {
  type: string;
}

// Brush for drawing shape objects.
class ComponentDrawingBrush extends DraggableBrush {
  private pointer: IPoint;

  constructor(
    public readonly canvas: Canvas,
    private readonly stylus: Stylus,
    protected componentName: ComponentNames
  ) {
    super();
  }

  async startDragging(pointer: IPoint) {
    return this.createObjects(pointer);
  }

  onMouseDown(pointer: IPoint, eventData: MouseEventData) {
    if (!this.canvas._isMainEvent(eventData.e)) {
      return;
    }
    this.pointer = pointer;
    this.canvas.controller.actionSetStylusMenu(null);
  }

  onMouseMove(): void {}

  onMouseUp(eventData: MouseEventData) {
    if (!this.canvas._isMainEvent(eventData.e)) {
      return true;
    }
    this.createObjects(eventData.pointer);
    this.stylus.drawingComplete();
    this.canvas.controller.undoManager.completeUndoGroup();

    return false;
  }

  // Creates the specified list of objects for the component
  createObjects = (pointer?: IPoint): fabric.Object => {
    const controller = this.canvas.controller;
    const componentName = this.componentName;
    return componentBuilder({
      controller,
      componentName,
      pointer: pointer ?? { x: 0, y: 0 },
    });
  };

  _render() {}
}

export default ComponentDrawingBrush;
